"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dropdownlist = function Dropdownlist(_ref) {
  var lang = _ref.lang,
      placeholder = _ref.placeholder,
      _ref$options = _ref.options,
      options = _ref$options === undefined ? [] : _ref$options;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      selectedOption = _useState4[0],
      setSelectedOption = _useState4[1];

  var dropdownRef = (0, _react.useRef)(null);
  var handleChange = function handleChange(option) {
    var selectedValue = (typeof option === "undefined" ? "undefined" : (0, _typeof3.default)(option)) === "object" ? option.name : option;
    if (!selectedValue) return; // Prevents navigation if the value is undefined

    setSelectedOption(selectedValue);
    setIsOpen(false);

    // Convert spaces to hyphens and navigate to the URL
    var formattedOption = selectedValue.toLowerCase().replace(/\s+/g, "-");
    var url = "https://mijn.stad-gemeente.be/" + formattedOption;

    window.location.href = url; // Redirect to the new URL
  };

  var handleClickOutside = function handleClickOutside(event) {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };
  var sortedOptions = (Array.isArray(options) ? options : (0, _values2.default)(options)).sort(function (a, b) {
    return (a.name || a).toString().localeCompare((b.name || b).toString());
  });
  (0, _react.useEffect)(function () {
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return _react2.default.createElement(
    "div",
    { ref: dropdownRef, style: { position: "relative", width: "250px", margin: "10px auto" } },
    _react2.default.createElement(
      "button",
      {
        onClick: function onClick() {
          return setIsOpen(!isOpen);
        },
        style: {
          width: "100%",
          padding: "10px",
          border: "1px solid #ccc",
          cursor: "pointer",
          textAlign: "left",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: "5px",
          fontSize: "12px",
          background: "transparent",
          boxShadow: "none",
          color: "#939598"
        }
      },
      selectedOption || placeholder,
      _react2.default.createElement(
        "span",
        { style: {
            transition: "transform 0.3s",
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)"
          } },
        "\u25BC"
      )
    ),
    isOpen && _react2.default.createElement(
      "div",
      {
        style: {
          position: "absolute",
          width: "100%",
          top: "100%",
          left: "0",
          border: "1px solid #ccc",
          borderRadius: "5px",
          cursor: "pointer",
          zIndex: 10,
          boxShadow: "none",
          background: "transparent",
          maxHeight: "100px",
          overflowY: "auto",
          padding: "2px",
          scrollBehavior: "smooth"
        }
      },
      options.length > 0 ? sortedOptions.map(function (option, index) {
        return _react2.default.createElement(
          "div",
          {
            key: index // Using index as key to avoid duplicate key issues
            , onClick: function onClick() {
              return handleChange(option);
            },
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "15px",
              backgroundColor: "white", // Ensures the background is white
              color: "green !important", // Ensures the text is black
              padding: "10px", // Optional padding for better spacing
              borderRadius: "5px", // Optional rounded corners for aesthetics
              boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)", // Optional subtle shadow
              fontSize: "10px" // Optional font size
            },
            onMouseEnter: function onMouseEnter(e) {
              return e.target.style.background = "#1794D2";
            },
            onMouseLeave: function onMouseLeave(e) {
              return e.target.style.background = "#fff";
            } // Fix: Restore background correctly
          },
          option.name || option
        );
      }) : _react2.default.createElement(
        "div",
        { style: { padding: "10px", fontSize: "12px", color: "#939598" } },
        "No options available"
      )
    )
  );
};

exports.default = Dropdownlist;